var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value.user_id && _vm.value.user)?_c('div',[_c('router-link',{attrs:{"to":{
            name: _vm.routeType.USER_EDIT,
            params: { userId: _vm.value.user_id },
        }}},[_vm._v(" "+_vm._s(_vm.value.user.name)+" ")]),_c('div',{staticClass:"mt-1 g-73--text"},[_vm._v(_vm._s(_vm.value.user.email))])],1):_c('div',[_vm._v("-")])}
var staticRenderFns = []

export { render, staticRenderFns }